module.exports = __webpack_public_path__ + "static/media/profile-card-bg.e1236261.jpg";